import {createApp} from '@shopify/app-bridge';

import {getSerialized} from '../utilities/server-data';

const {apiKey} = getSerialized();

export const appBridge = createApp({
  apiKey,
  host: window.shopify.config.host ?? '',
});
